import script from "./DCookie.vue?vue&type=script&setup=true&lang=js"
export * from "./DCookie.vue?vue&type=script&setup=true&lang=js"

import "./DCookie.vue?vue&type=style&index=0&id=a17e64b6&lang=css"

const __exports__ = script;

export default __exports__